// src/pages/MenuPage.js - FIXED: Proper Button Click Behavior!
import React, { useState, useEffect } from 'react';
import { useCart } from '../context/CartContext';
import { useProfile } from '../context/ProfileContext';
import { toast } from 'react-toastify';

const MenuPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('original');
  const { addToCart, isInCart, getItemQuantity } = useCart();
  const { profile, addToFavorites, removeFromFavorites } = useProfile();
  const categories = [
    { id: 'All', name: 'All Dishes', icon: '🍽️', color: '#008751' },
    { id: 'Rice', name: 'Rice Dishes', icon: '🍚', color: '#fb923c' },
    { id: 'Traditional', name: 'Traditional Dishes', icon: '🍲', color: '#4f46e5' },
    { id: 'Grilled', name: 'Grilled', icon: '🥩', color: '#059669' },
    { id: 'Soups', name: 'Soups', icon: '🍲', color: '#7c3aed' },
    { id: 'Drinks', name: 'Drinks', icon: '🥤', color: '#0891b2' },
    { id: 'Pasta', name: 'Pasta', icon: '🍝', color: '#fbbf24' },
    { id: 'Swallow', name: 'Swallow', icon: '🍲', color: '#7c3aed' },
    { id: 'Pastries', name: 'Pastries', icon: '🍰', color: '#fbbf24' },
    { id: 'Gluten Free', name: 'Gluten Free', icon: '🥤', color: '#0891b2' },
    { id: 'Vegan', name: 'Vegan', icon: '🥗', color: '#4caf50' },
    { id: 'Vegetarian', name: 'Vegetarian', icon: '🥗', color: '#4caf50' },
    { id: 'Ice Cream', name: 'Ice Cream', icon: '🍦', color: '#fbbf24' },
    { id: 'Yam spice', name: 'Yam spice', icon: '🍠', color: '#fbbf24' }
  ];

  // ...existing menuItems array stays the same...
  const menuItems = [
    // Rice Dishes
    {
      id: 1,
      name: 'Jollof Rice',
      description: 'Authentic Nigerian party jollof rice with tender chicken pieces and aromatic spices',
      price: 3700,
      image: '/images/categories/Rice Boxes/jollof-rice.jpg',
      rating: 4.9,
      category: 'Rice',
      popular: true,
      spicyLevel: 2,
      prepTime: '25 min',
      ingredients: ['rice', 'Chicken', 'Tomatoes', 'Onions', 'Bell peppers', 'Spices']
    },
    {
      id: 2,
      name: 'Fried Rice',
      description: 'Authentic Nigerian party fried rice with tender chicken pieces and aromatic spices',
      price: 3500,
      image: '/images/categories/Rice Boxes/fried-rice.jpg',
      rating: 4.4,
      category: 'Rice',
      popular: true,
      spicyLevel: 1,
      prepTime: '25 min',
      ingredients: ['Fried rice']
    },
    {
      id: 3,
      name: 'Coconut Rice',
      description: 'Fragrant coconut rice cooked with mixed vegetables and your choice of protein',
      price: 2800,
      image: '/images/coconut-rice.jpg',
      rating: 4.3,
      category: 'Rice',
      popular: false,
      spicyLevel: 2,
      prepTime: '30 min',
      ingredients: ['Coconut rice', 'Mixed vegetables', 'Protein of choice', 'Spices']
    },
    {
      id: 4,
      name: 'Ofada',
      description: 'Nigerian Grown Ofada Rice with assorted meats and spices',
      price: 4000,
      image: '/images/categories/Rice Boxes/fried-rice-supreme.jpg',
      rating: 4.8,
      category: 'Rice',
      popular: false,
      spicyLevel: 3,
      prepTime: '30 min',
      ingredients: ['Ofada rice', 'Assorted meats', 'Spices']
    },
    
    // Traditional Dishes
    {
      id: 5,
      name: 'Akara and Pap',
      description: 'Delicious bean cakes served with a side of pap (fermented corn pudding)',
      price: 2500,
      image: '/images/categories/Breakfast-images/akara and pap.jpeg',
      rating: 4.9,
      category: 'Traditional',
      popular: true,
      spicyLevel: 2,
      prepTime: '25 min',
      ingredients: ['Bean cakes', 'Pap', 'Spices']
    },
    {
      id: 6,
      name: 'Amala',
      description: 'Delicious amala served with a variety of soups',
      price: 2500,
      image: '/images/categories/Swallow/amala.jpeg',
      rating: 5.0,
      category: 'Traditional',
      popular: true,
      spicyLevel: 2,
      prepTime: '40 min',
      ingredients: ['Amala', 'Variety of soups', 'Spices']
    },

    // Grilled Items
    {
      id: 7,
      name: 'Asun',
      description: 'Spicy grilled goat meat skewers with peppers and onions',
      price: 2500,
      image: '/images/chef/Asun.jpeg',
      rating: 4.1,
      category: 'Grilled',
      popular: true,
      spicyLevel: 3,
      prepTime: '25 min',
      ingredients: ['Goat meat', 'Peppers', 'Onions', 'Spices']
    },
    {
      id: 8,
      name: 'Grilled Chicken',
      description: 'Juicy grilled chicken marinated in Nigerian spices',
      price: 8500,
      image: '/images/grilled-chicken.jpg',
      rating: 4.4,
      category: 'Grilled',
      popular: true,
      spicyLevel: 2,
      prepTime: '25 min',
      ingredients: ['Chicken', 'Tomatoes', 'Onions', 'Bell peppers', 'Spices']
    },
    
    // Ice Cream
    {
      id: 9,
      name: 'Chocolate Ice Cream',
      description: 'Rich and creamy chocolate ice cream made with real cocoa',
      price: 2500,
      image: '/images/categories/Ice cream/chocolate-ice-Cream.webp',
      rating: 4.9,
      category: 'Ice Cream',
      popular: true,
      spicyLevel: 0,
      prepTime: '20 min',
      ingredients: ['Chocolate', 'Cream', 'Sugar', 'Vanilla', 'Cocoa powder']
    },
    {
      id: 10,
      name: 'Coconut Milk Ice Cream',
      description: 'Creamy coconut milk ice cream with a hint of vanilla',
      price: 3850,
      image: '/images/categories/Ice cream/coconut-Milk-Ice-Cream.jpg',
      rating: 4.9,
      category: 'Ice Cream',
      popular: true,
      spicyLevel: 0,
      prepTime: '20 min',
      ingredients: ['Coconut milk', 'Sugar', 'Vanilla', 'Salt']
    },
    
    {
      id: 11,
      name: 'Oreo Ice Cream',
      description: 'Creamy Oreo ice cream with chunks of real Oreo cookies',
      price: 4750,
      image: '/images/categories/Ice cream/oreo-ice-cream.jpg',
      rating: 4.4,
      category: 'Ice Cream',
      popular: true,
      spicyLevel: 0,
      prepTime: '20 min',
      ingredients: ['Oreo cookies', 'Cream', 'Sugar', 'Vanilla']
    },
    {
      id: 12,
      name: 'Strawberry Ice Cream',
      description: 'Creamy strawberry ice cream with chunks of real strawberries',
      price: 4750,
      image: '/images/categories/Ice cream/strawberry-ice-cream.jpg',
      rating: 4.8,
      category: 'Ice Cream',
      popular: true,
      spicyLevel: 0,
      prepTime: '20 min',
      ingredients: ['Strawberries', 'Cream', 'Sugar', 'Vanilla']
    },
    
    // Drinks
    {
      id: 13,
      name: 'Water',
      description: 'Pure and refreshing bottled water',
      price: 500,
      image: '/images/categories/Drinks/water.jpeg',
      rating: 4.0,
      category: 'Drinks',
      popular: true,
      spicyLevel: 0,
      prepTime: '5 min',
    },
    {
      id: 14,
      name: 'Campari',
      description: 'Refreshing Campari drink with a hint of orange',
      price: 2500,
      image: '/images/categories/Drinks/campari.webp',
      rating: 4.3,
      category: 'Drinks',
      popular: true,
      spicyLevel: 0,
      prepTime: '5 min',
    },
    {
      id: 15,
      name: 'Hennessy',
      description: 'Smooth and rich Hennessy cognac with fruity notes',
      price: 2500,
      image: '/images/categories/Drinks/Hennessy Cognac.jpg',
      rating: 4.2,
      category: 'Drinks',
      popular: true,
      spicyLevel: 0,
      prepTime: '5 min',
    },
    {
      id: 16,
      name: 'Palm Wine',
      description: 'Traditional Nigerian palm wine with a sweet and tangy flavor',
      price: 2000,
      image: '/images/categories/Drinks/Palm-Wine.jpg',
      rating: 4.6,
      category: 'Drinks',
      popular: true,
      spicyLevel: 0,
      prepTime: '5 min',
    },
    {
      id: 17,
      name: 'Sprite',
      description: 'Crisp and refreshing lemon-lime soda',
      price: 2500,
      image: '/images/categories/Drinks/sprite.jpg',
      rating: 4.5,
      category: 'Drinks',
      popular: true,
      spicyLevel: 0,
      prepTime: '5 min',
    },

    // Pasta
    {
      id: 18,
      name: 'Alfredo Pasta',
      description: 'Creamy Alfredo pasta with a rich and savory sauce',
      price: 9500,
      image: '/images/categories/Pasta/alfredopasta.webp',
      rating: 4.9,
      category: 'Pasta',
      popular: true,
      spicyLevel: 3,
      prepTime: '35 min',
      ingredients: ['Pasta']
    },
    {
      id: 19,
      name: 'Creamy Garlic Pasta',
      description: 'Authentic Nigerian party jollof rice with tender chicken pieces and aromatic spices',
      price: 10500,
      image: '/images/categories/Pasta/creamy-garlic-pasta.jpg',
      rating: 4.4,
      category: 'Pasta',
      popular: false,
      spicyLevel: 2,
      prepTime: '45 min',
      ingredients: ['Pasta', 'Garlic', 'Tomatoes', 'Onions', 'Bell peppers', 'Spices']
    },
    
    // Swallow Dishes
    {
      id: 20,
      name: 'Amala',
      description: 'Delicious amala served with a variety of soups',
      price: 2500,
      image: '/images/categories/Swallow/amala.jpeg',
      rating: 5.0,
      category: 'Swallow',
      popular: true,
      spicyLevel: 2,
      prepTime: '40 min',
      ingredients: ['Amala', 'Variety of soups', 'Spices']
    },
    {
      id: 21,
      name: 'Eba',
      description: 'Nigerian made local Garri Swallow meal',
      price: 500,
      image: '/images/categories/Swallow/Eba.jpg',
      rating: 4.9,
      category: 'Swallow',
      popular: true,
      spicyLevel: 0,
      prepTime: '25 min',
      ingredients: ['Garri', 'Water', 'Spices']
    },
    {
      id: 22,
      name: 'Fufu',
      description: 'Authentic Nigerian fufu made from cassava and plantains',
      price: 500,
      image: '/images/categories/Swallow/Fufu.jpeg',
      rating: 4.2,
      category: 'Swallow',
      popular: false,
      spicyLevel: 0,
      prepTime: '25 min',
      ingredients: ['Cassava', 'Plantains', 'Water', 'Spices']
    },
    {
      id: 23,
      name: 'Semo',
      description: 'Authentic Nigerian semovita served with a variety of soups',
      price: 3500,
      image: '/images/categories/Swallow/Semo.jpeg',
      rating: 4.1,
      category: 'Swallow',
      popular: true,
      spicyLevel: 0,
      prepTime: '25 min',
      ingredients: ['Semovita', 'Variety of soups', 'Spices']
    },
    {
      id: 24,
      name: 'Starch',
      description: 'Authentic Nigerian starch served with a variety of soups',
      price: 500,
      image: '/images/categories/Swallow/Starch.jpeg',
      rating: 4.0,
      category: 'Swallow',
      popular: false,
      spicyLevel: 0,
      prepTime: '25 min',
      ingredients: ['Starch', 'Variety of soups', 'Spices']
    },
    {
      id: 25,
      name: 'Wheat',
      description: 'Authentic Nigerian wheat served with a variety of soups',
      price: 3500,
      image: '/images/categories/Swallow/Wheat.jpeg',
      rating: 4.2,
      category: 'Swallow',
      popular: false,
      spicyLevel: 0,
      prepTime: '25 min',
      ingredients: ['Wheat', 'Variety of soups', 'Spices']
    },

    // Pastries
    {
      id: 26,
      name: 'Banana Bread (Nut mix)',
      description: 'Soft Brown Bread made with Banana and a mix of Nut',
      price: 7500,
      image: '/images/categories/pastries/Banana bread (nut mix).jpeg',
      rating: 4.3,
      category: 'Pastries',
      popular: false,
      spicyLevel: 0,
      prepTime: '40 min',
      ingredients: ['Banana', 'Nuts', 'Flour', 'Sugar', 'Eggs', 'Butter']
    },
    {
      id: 27,
      name: 'Plain Bread',
      description: 'Authentic Nigerian party jollof rice with tender chicken pieces and aromatic spices',
      price: 2800,
      image: '/images/categories/pastries/Bread plain.jpeg',
      rating: 5.0,
      category: 'Pastries',
      popular: true,
      spicyLevel: 0,
      prepTime: '35 min',
      ingredients: ['Flour', 'Sugar', 'Eggs', 'Butter']
    },
    {
      id: 28,
      name: 'Cake',
      description: 'Deliciously moist cake made with fresh ingredients',
      price: 12500,
      image: '/images/categories/pastries/Cakes.jpeg',
      rating: 4.9,
      category: 'Pastries',
      popular: false,
      spicyLevel: 0,
      prepTime: '35 min',
      ingredients: ['Flour', 'Sugar', 'Eggs', 'Butter']
    },
    {
      id: 29,
      name: 'Meat Pie',
      description: 'Delicious meat pie filled with spiced minced meat and vegetables',
      price: 2500,
      image: '/images/categories/pastries/meat-pie.jpg',
      rating: 4.9,
      category: 'Pastries',
      popular: true,
      spicyLevel: 2,
      prepTime: '25 min',
      ingredients: ['Flour', 'Sugar', 'Eggs', 'Butter', 'Minced meat', 'Vegetables']
    },
    {
      id: 30,
      name: 'Chicken Pie',
      description: 'Delicious chicken pie filled with spiced minced chicken and vegetables',
      price: 1800,
      image: '/images/categories/pastries/chicken-pie.jpeg',
      rating: 4.9,
      category: 'Pastries',
      popular: true,
      spicyLevel: 2,
      prepTime: '25 min',
      ingredients: ['Flour', 'Sugar', 'Eggs', 'Butter', 'Minced meat', 'Vegetables']
    },
    {
      id: 31,
      name: 'Tortilla Wrap(Beef)',
      description: 'Delicious tortilla wrap filled with spiced minced beef and vegetables',
      price: 4500,
      image: '/images/categories/pastries/Tortilla wrap(beef).jpeg',
      rating: 4.9,
      category: 'Pastries',
      popular: true,
      spicyLevel: 2,
      prepTime: '25 min',
      ingredients: ['Beef']
    },
    {
      id: 32,
      name: 'Tortilla Wrap(Chicken)',
      description: 'Delicious tortilla wrap filled with spiced minced chicken and vegetables',
      price: 4500,
      image: '/images/categories/pastries/Tortilla wrap(chicken).jpeg',
      rating: 4.9,
      category: 'Pastries',
      popular: true,
      spicyLevel: 2,
      prepTime: '25 min',
      ingredients: ['chicken']
    },

    // Soup
    {
      id: 33,
      name: 'Egusi',
      description: 'Melon Soup with sweet and savory flavors and a hint of spice',
      price: 2000,
      image: '/images/categories/soup/Egusi.jpeg',
      rating: 4.9,
      category: 'Soups',
      popular: true,
      spicyLevel: 2,
      prepTime: '25 min',
      ingredients: ['Melon', 'Spices', 'Vegetables']
    },
    {
      id: 34,
      name: 'Goat Meat Pepper Soup',
      description: 'Spicy goat meat soup with a rich and flavorful broth',
      price: 5000,
      image: '/images/categories/soup/goat-meat-pepper-soup.webp',
      rating: 4.9,
      category: 'Soups',
      popular: true,
      spicyLevel: 4,
      prepTime: '25 min',
      ingredients: ['Goat meat', 'Spices', 'Vegetables']
    },
    {
      id: 35,
      name: 'Efo Riro',
      description: 'Authentic Nigerian vegetable soup with a rich and flavorful broth',
      price: 2500,
      image: '/images/categories/soup/Efo-Riro.jpg',
      rating: 4.6,
      category: 'Soups',
      popular: false,
      spicyLevel: 2,
      prepTime: '25 min',
      ingredients: ['Melon', 'Spices', 'Vegetables']
    },
    {
      id: 36,
      name: 'Edikang Ikong',
      description: 'Authentic Nigerian vegetable soup with a rich and flavorful broth',
      price: 2500,
      image: '/images/categories/soup/Edikang Ikong.jpeg',
      rating: 4.9,
      category: 'Soups',
      popular: false,
      spicyLevel: 2,
      prepTime: '25 min',
      ingredients: ['Melon', 'Spices', 'Vegetables']
    },

    // Vegan
    {
      id: 37,
      name: 'Avocado Toast',
      description: 'Creamy avocado spread on toasted bread, topped with fresh tomatoes and spices',
      price: 3700,
      image: '/images/categories/vegan/avocado-toast-1.jpg',
      rating: 4.9,
      category: 'Vegan',
      popular: true,
      spicyLevel: 1,
      prepTime: '25 min',
      ingredients: ['Avocado', 'Bread', 'Tomatoes', 'Spices']
    },
    {
      id: 38,
      name: 'Ponzu Tofu',
      description: 'Delicious tofu marinated in ponzu sauce, served with steamed rice and vegetables',
      price: 2500,
      image: '/images/categories/vegan/ponzu-tofu-poke.jpg',
      rating: 4.9,
      category: 'Vegan',
      popular: true,
      spicyLevel: 1,
      prepTime: '25 min',
      ingredients: ['Tofu', 'Ponzu sauce', 'Rice', 'Vegetables']
    },

    // Vegetarian
    {
      id: 39,
      name: 'Vegetable Salad',
      description: 'Fresh mixed salad with a variety of vegetables and a tangy dressing',
      price: 3500,
      image: '/images/categories/vegetarian-images/vegie salad.jpg',
      rating: 4.3,
      category: 'Vegetarian',
      popular: true,
      spicyLevel: 0,
      prepTime: '25 min',
      ingredients: ['Lettuce', 'Tomatoes', 'Cucumbers', 'Carrots', 'Dressing']
    },
    {
      id: 40,
      name: 'Vegetable stir Fry',
      description: 'Stir-fried mixed vegetables with a savory sauce',
      price: 2900,
      image: '/images/categories/vegetarian-images/Stir-fried veggies.jpg',
      rating: 4.9,
      category: 'Vegetarian',
      popular: true,
      spicyLevel: 1,
      prepTime: '25 min',
      ingredients: ['Mixed vegetables', 'Soy sauce', 'Garlic', 'Ginger', 'Spices']
    },

    // Yam Spice
    {
      id: 41,
      name: 'Potato Fries',
      description: 'Crispy fried potato strips seasoned with spices',
      price: 2500,
      image: '/images/categories/Yamspice/potato-fries.jpg',
      rating: 4.9,
      category: 'Yam spice',
      popular: true,
      spicyLevel: 2,
      prepTime: '25 min',
      ingredients: ['Potatoes', 'Spices', 'Oil']
    },

    // Gluten Free
    {
      id: 42,
      name: 'Quinoa Power Salad',
      description: 'A protein-packed salad with quinoa, black beans, corn, and avocado',
      price: 2500,
      image: '/images/categories/Gluten-free-images/Quinoa power salad.jpg',
      rating: 4.9,
      category: 'Gluten Free',
      popular: true,
      spicyLevel: 1,
      prepTime: '25 min',
      ingredients: ['Quinoa', 'Black beans', 'Corn', 'Avocado', 'Lime', 'Spices']
    },
    {
      id: 43,
      name: 'Scallop and Pork belly',
      description: 'Succulent scallops and tender pork belly served with a flavorful sauce',
      price: 2500,
      image: '/images/categories/Gluten-free-images/scallop and pork belly.jpg',
      rating: 4.9,
      category: 'Gluten Free',
      popular: true,
      spicyLevel: 2,
      prepTime: '25 min',
      ingredients: ['Scallops', 'Pork belly', 'Garlic', 'Butter', 'Lemon', 'Spices']
    },
  ];

  // Filter and sort items
  const filteredItems = menuItems
    .filter(item => {
      const matchesCategory = selectedCategory === 'All' || item.category === selectedCategory;
      const matchesSearch = item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                           item.description.toLowerCase().includes(searchTerm.toLowerCase());
      return matchesCategory && matchesSearch;
    })
    .sort((a, b) => {
      switch (sortBy) {
        case 'price-low': return a.price - b.price;
        case 'price-high': return b.price - a.price;
        case 'rating': return b.rating - a.rating;
        case 'popular': return b.popular - a.popular;
        case 'name': return a.name.localeCompare(b.name);
        case 'original':
        default: return 0;
      }
    });

  const getSpicyIcons = (level) => {
    if (level === 0) return '😊 Mild';
    return '🌶️'.repeat(level);
  };

  const isFavorite = (itemId) =>
    (profile.favoriteItems || []).some(fav => fav.id === itemId);

  return (
    <div className="main-container menu-page" style={{ background: '...', minHeight: '100vh' }}>
      {/* Header */}
      <section style={{
        background: 'linear-gradient(135deg, #008751, #fb923c)',
        color: 'white',
        padding: '4rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{
            fontSize: '3.5rem',
            fontWeight: '900',
            marginBottom: '1rem',
            textShadow: '3px 3px 6px rgba(0,0,0,0.4)'
          }}>
            🍽️ Our Delicious Menu 🇳🇬
          </h1>
          <p style={{
            fontSize: '1.3rem',
            opacity: 0.95,
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            Discover authentic Nigerian flavors crafted with love and tradition
          </p>
        </div>
      </section>

      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '3rem 2rem'
      }}>
        {/* Search and Filters */}
        <div style={{
          background: 'white',
          padding: '2rem',
          borderRadius: '25px',
          boxShadow: '0 12px 30px rgba(0,0,0,0.1)',
          marginBottom: '3rem'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '1.5rem',
            alignItems: 'center'
          }}>
            {/* Search */}
            <div>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '700',
                color: '#008751'
              }}>
                🔍 Search Dishes
              </label>
              <input
                type="text"
                placeholder="Search for your favorite dish..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: '100%',
                  padding: '1rem',
                  border: '2px solid #e9ecef',
                  borderRadius: '15px',
                  fontSize: '1rem',
                  outline: 'none',
                  transition: 'all 0.3s ease'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#008751';
                  e.target.style.boxShadow = '0 0 15px rgba(0, 135, 81, 0.2)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e9ecef';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            {/* Sort */}
            <div>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '700',
                color: '#008751'
              }}>
                📊 Sort By
              </label>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                style={{
                  width: '100%',
                  padding: '1rem',
                  border: '2px solid #e9ecef',
                  borderRadius: '15px',
                  fontSize: '1rem',
                  outline: 'none',
                  background: 'white',
                  cursor: 'pointer'
                }}
              >
                <option value="original">Original Order 📋</option>
                <option value="name">Name (A-Z) 🔤</option>
                <option value="price-low">Price (Low to High) 💰</option>
                <option value="price-high">Price (High to Low) 💎</option>
                <option value="rating">Rating (Highest) ⭐</option>
                <option value="popular">Most Popular 🔥</option>
              </select>
            </div>
          </div>
        </div>

        {/* Categories - FIXED: Proper Button Behavior */}
        <div style={{
          background: 'white',
          padding: '2rem',
          borderRadius: '25px',
          boxShadow: '0 12px 30px rgba(0,0,0,0.1)',
          marginBottom: '3rem'
        }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#008751',
            marginBottom: '1.5rem',
            textAlign: 'center'
          }}>
            🏷️ Categories
          </h2>
          
          <div style={{
            display: 'flex',
            gap: '1rem',
            flexWrap: 'wrap',
            justifyContent: 'center'
          }}>
            {categories.map(category => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                style={{
                  background: selectedCategory === category.id 
                    ? `linear-gradient(135deg, ${category.color}, #fb923c)`
                    : 'transparent',
                  color: selectedCategory === category.id ? 'white' : category.color,
                  border: `2px solid ${category.color}`,
                  padding: '1rem 2rem',
                  borderRadius: '25px',
                  fontWeight: '800',
                  fontSize: '1rem',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
                onMouseOver={(e) => {
                  if (selectedCategory !== category.id) {
                    e.target.style.background = `${category.color}15`;
                    e.target.style.transform = 'translateY(-2px)';
                  }
                }}
                onMouseOut={(e) => {
                  if (selectedCategory !== category.id) {
                    e.target.style.background = 'transparent';
                    e.target.style.transform = 'translateY(0)';
                  }
                }}
              >
                {/* FIXED: Text inside buttons can't interfere with clicks */}
                <span style={{ pointerEvents: 'none' }}>{category.icon}</span>
                <span style={{ pointerEvents: 'none' }}>{category.name}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Menu Items Grid */}
        <div className="menu-grid">
          {filteredItems.map(item => (
            <div key={item.id} style={{
              background: 'white',
              borderRadius: '25px',
              padding: '2rem',
              boxShadow: '0 12px 30px rgba(0,0,0,0.1)',
              border: '2px solid #f8f9fa',
              transition: 'all 0.4s ease',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-10px)';
              e.target.style.borderColor = '#fb923c';
              e.target.style.boxShadow = '0 20px 50px rgba(0,0,0,0.15)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.borderColor = '#f8f9fa';
              e.target.style.boxShadow = '0 12px 30px rgba(0,0,0,0.1)';
            }}
            >
              {/* Popular Badge */}
              {item.popular && (
                <div style={{
                  position: 'absolute',
                  top: '1rem',
                  right: '1rem',
                  background: 'linear-gradient(135deg, #ff6b6b, #ff4757)',
                  color: 'white',
                  padding: '0.5rem 1rem',
                  borderRadius: '20px',
                  fontSize: '0.8rem',
                  fontWeight: '800',
                  animation: 'pulse 2s infinite',
                  zIndex: 2,
                  pointerEvents: 'none' // FIXED: Badge can't interfere with clicks
                }}>
                  🔥 Popular
                </div>
              )}

              {/* Food Image */}
              <div style={{
                width: '100%',
                height: '250px',
                borderRadius: '20px',
                overflow: 'hidden',
                marginBottom: '1.5rem',
                position: 'relative',
                boxShadow: '0 8px 25px rgba(0,0,0,0.1)'
              }}>
                <img
                  src={item.image}
                  alt={item.name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'transform 0.4s ease',
                    pointerEvents: 'none' // FIXED: Image can't interfere with card hover
                  }}
                />
                {/* Fallback emoji display */}
                <div style={{
                  display: 'none',
                  width: '100%',
                  height: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'linear-gradient(135deg, #f8f9fa, #e9ecef)',
                  fontSize: '5rem',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  pointerEvents: 'none'
                }}>
                  🍽️
                </div>
              </div>

              {/* Item Details - FIXED: Text can't interfere */}
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: '900',
                color: '#008751',
                marginBottom: '0.8rem',
                textAlign: 'center',
                pointerEvents: 'none'
              }}>
                {item.name}
              </h3>

              <p style={{
                color: '#6b7280',
                lineHeight: '1.6',
                marginBottom: '1.5rem',
                textAlign: 'center',
                fontSize: '1rem',
                pointerEvents: 'none'
              }}>
                {item.description}
              </p>

              {/* Item Info - FIXED: Info can't interfere */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem',
                fontSize: '0.9rem',
                pointerEvents: 'none'
              }}>
                <span style={{ color: '#6b7280' }}>
                  ⏱️ {item.prepTime}
                </span>
                <span style={{ color: '#6b7280' }}>
                  {getSpicyIcons(item.spicyLevel)}
                </span>
                <span style={{ color: '#6b7280' }}>
                  ⭐ {item.rating}
                </span>
              </div>

              {/* Price and Cart Status - FIXED */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1.5rem',
                pointerEvents: 'none'
              }}>
                <span style={{
                  fontSize: '1.6rem',
                  fontWeight: '900',
                  color: '#fb923c'
                }}>
                  ₦{item.price.toLocaleString()}
                </span>
                
                {isInCart(item.id) && (
                  <span style={{
                    background: '#22c55e',
                    color: 'white',
                    padding: '0.3rem 0.8rem',
                    borderRadius: '15px',
                    fontSize: '0.8rem',
                    fontWeight: '700'
                  }}>
                    {getItemQuantity(item.id)} in cart ✓
                  </span>
                )}
              </div>

              {/* Add to Cart Button - FIXED: Perfect Click Behavior */}
              <button
                onClick={() => {
                  addToCart(item);
                  toast.success('Added to cart!');
                }}
                style={{
                  width: '100%',
                  background: 'linear-gradient(135deg, #008751, #fb923c)',
                  color: 'white',
                  border: 'none',
                  padding: '1.2rem',
                  borderRadius: '18px',
                  fontWeight: '900',
                  fontSize: '1.1rem',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-3px)';
                  e.target.style.boxShadow = '0 10px 30px rgba(0, 135, 81, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                {/* FIXED: Button text can't interfere with clicks */}
                <span style={{ pointerEvents: 'none' }}>🛒 Add to Cart</span>
              </button>

              {/* Favorite Button - NEW: Add to Favorites functionality */}
              <button
                onClick={() =>
                  isFavorite(item.id)
                    ? removeFromFavorites(item.id)
                    : addToFavorites(item)
                }
                style={{
                  position: 'absolute',
                  top: '1rem',
                  left: '1rem',
                  background: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.3rem',
                  color: isFavorite(item.id) ? '#fb923c' : '#d1d5db',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                  cursor: 'pointer',
                  zIndex: 2
                }}
                title={isFavorite(item.id) ? 'Remove from Favorites' : 'Add to Favorites'}
              >
                <span style={{ pointerEvents: 'none' }}>
                  {isFavorite(item.id) ? '❤️' : '🤍'}
                </span>
              </button>
            </div>
          ))}
        </div>

        {/* No Results */}
        {filteredItems.length === 0 && (
          <div style={{
            textAlign: 'center',
            background: 'white',
            padding: '4rem 2rem',
            borderRadius: '25px',
            boxShadow: '0 12px 30px rgba(0,0,0,0.1)'
          }}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🔍</div>
            <h3 style={{
              fontSize: '2rem',
              fontWeight: '800',
              color: '#6b7280',
              marginBottom: '1rem'
            }}>
              No dishes found
            </h3>
            <p style={{ color: '#9ca3af', fontSize: '1.1rem' }}>
              Try adjusting your search or category filter
            </p>
          </div>
        )}
      </div>

      {/* Checkout Container - NEW: Dedicated section for checkout */}
      <div className="checkout-container" style={{
        maxWidth: '700px',
        margin: '2rem auto',
        background: 'white',
        borderRadius: '25px',
        boxShadow: '0 12px 30px rgba(0,0,0,0.1)',
        padding: '2.5rem'
      }}>
        {/* Checkout content will go here */}
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }

        .main-container.menu-page,
        .main-container.menu-page section {
          box-sizing: border-box;
          width: 100%;
          max-width: 100vw;
          overflow-x: hidden;
        }
        .menu-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 2rem;
          width: 100%;
        }
        @media (max-width: 900px) {
          .main-container.menu-page h1 {
            font-size: 2rem !important;
          }
        }
        @media (max-width: 600px) {
          .main-container.menu-page .section {
            padding: 1rem 0 !important;
          }
          .menu-grid {
            grid-template-columns: 1fr !important;
            gap: 1rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default MenuPage;